<app-header></app-header>
<div
  class="wrapper"
  infiniteScroll
  [infiniteScrollDistance]="1"
  [infiniteScrollThrottle]="150"
  (scrolled)="onScroll()"
  [infiniteScrollDisabled]="shimarStatus"
>
  <section
    class="related-search upcoming partner-list"
    *ngIf="!shimarStatus && partnerList?.length > 0"
  >
    <div class="container">
      <div class="section-head p-0">
        <h2>{{ gridConfig.grid_content.partnerContent }}</h2>
      </div>

      <div class="row custome-set">
        <div
          class="series-box"
          *ngFor="let partner of partnerList; let i = index"
        >
          <app-grid
            [data]="partner"
            [gridType]="'square'"
            [type]="'partner_list'"
          ></app-grid>
        </div>
      </div>
    </div>

    <div class="w-100" *ngIf="loadMore">
      <app-grid-simmer class="search-page"></app-grid-simmer>
    </div>
  </section>
  <div
    class="record-not-available"
    *ngIf="partnerList?.length === 0 && !shimarStatus"
  >
    <div class="text-center">
      <img src="assets/images/no-recoard-playlist.png" />
      <p class="no-recored-content text-secondary">
        {{ "RECORD_NOT_FOUND" | translate }}
      </p>
    </div>
  </div>

  <app-grid-simmer class="search-page" *ngIf="shimarStatus"></app-grid-simmer>
</div>
<app-footer></app-footer>
